export const ErrorHandler = error => {
  const { response } = error;
  if (response && response.status === 404) {
    window.location.href = '/not-found';
  }
  return Promise.reject(error.response);
};
